import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { ToastType } from '../../../core';
import { addToast } from '../../../core/actions';
import { update, fetchById } from '../../actions';
import { selectSsoServices } from '../../selectors';
import { AdminSsoForm } from '../AdminSsoForm';
export const AdminSsoEdit = () => {
    const params = useParams();
    const id = Number(params.id);
    const dispatch = useDispatch();
    const history = useHistory();
    const [isDisabled, setIsDisabled] = useState(false);
    const [errors, setErrors] = useState({});
    const ssoServices = useSelector(selectSsoServices);
    const ssoService = ssoServices.find((s) => s.id === id);
    useEffect(() => {
        if (!ssoService) {
            void dispatch(fetchById(id));
        }
    }, [dispatch, id, ssoService]);
    const onSubmit = async (data) => {
        setIsDisabled(true);
        try {
            await dispatch(update(id, data));
            history.push(`/account/admin/sso-services/list`);
        }
        catch (e) {
            const errs = e.data?.error?.data;
            setIsDisabled(false);
            if (Boolean(errs)) {
                setErrors(errs);
            }
            else {
                dispatch(addToast(ToastType.error, e.message));
            }
        }
    };
    if (!ssoService) {
        return null;
    }
    return (<>
      <header className="settings-header">
        <h2 className="header-title">Edit {ssoService.name} </h2>
      </header>

      <AdminSsoForm onSubmit={(...data) => void onSubmit(...data)} isDisabled={isDisabled} errors={errors} ssoService={ssoService} btnMessage="Update"/>
    </>);
};
